import { Component, inject } from '@angular/core';

import { TurnstileWidgetDirective } from '../../../core/directives/turnstile-widget.directive';
import { TurnstileVerificationService } from '../../../core/services/turnstile-verification.service';
import { TranslatePipe } from '../../../core/pipes/translate.pipe';

/**
 * Container de shell (mismo nivel que HeaderComponent/FooterComponent), NO
 * una ruta -- por eso inyecta TurnstileVerificationService directo, sin
 * ViewModel intermedio, misma excepcion ya documentada para
 * <demo-theme-toggle>/<demo-language-switcher>. AppComponent solo renderiza este
 * componente mientras `turnstile.verified()` sea false -- ver
 * app.component.html, que es el gate real (nada mas se monta antes).
 */
@Component({
  selector: 'demo-turnstile-gate',
  standalone: true,
  imports: [TurnstileWidgetDirective, TranslatePipe],
  templateUrl: './turnstile-gate.component.html',
  styleUrl: './turnstile-gate.component.css',
})
export class TurnstileGateComponent {
  protected readonly turnstile = inject(TurnstileVerificationService);
}
